export default "__VITE_ASSET__887ab4df__"